import { ComponentType } from '@angular/cdk/portal';
import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/services/utility.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { NgForm } from "@angular/forms";
import { DrupalRESTService } from "src/app/services/drupal-rest.service";
import { ActivatedRoute, Event, Params, Router } from "@angular/router";
import { saveAs } from 'file-saver';
import moment from 'moment';
import { DialogService } from 'src/app/services/dialog.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { PaymentsEntityComponent } from '../../forms/payments-entity/payments-entity.component';
import { EventLessonEntityComponent } from '../../forms/event-lesson-entity/event-lesson-entity.component';
import { EnrollmentEntityComponent } from '../../forms/enrollment-entity/enrollment-entity.component';
import { SendUpdateAPIComponent } from '../../forms/send-update-api/send-update-api.component';
import { BaseComponent } from '../../forms/base-form/base-form.component';
import { EventServicesEntityComponent } from '../../forms/event-services-entity/event-services-entity.component';
import { EventGroupLessonEntityComponent } from '../../forms/event-group-lesson-entity/event-group-lesson-entity.component';
import { EventSchedulesEntityComponent } from '../../forms/event-schedules-entity/event-schedules-entity.component';
import { EnrollmentDropComponent } from '../../forms/enrollment-drop/enrollment-drop.component';
import { StudentInquiryDetailsComponent } from '../../forms/student-inquiry-details/student-inquiry-details.component';
import { EnrollmentViewLessonComponent } from '../../forms/enrollment-view-lesson/enrollment-view-lesson.component';
import { MiscServiceDeductionsEntityComponent } from '../../forms/misc-service-deductions-entity/misc-service-deductions-entity.component';
import { HttpParameter } from 'src/app/types/http-parameter';
import { SignatureEnrollmentComponent } from '../../enrollment/signature-enrollment/signature-enrollment.component';
import { Subscription } from 'rxjs';
import { ReportDateService } from 'src/app/services/report-date.service';
import { LoggerService } from '../../../services/logger.service';

@Component({ template: '' })

/**
 * Base class to be extended.
 */
export class ViewTableComponent extends BaseComponent implements OnInit {
  private subscription: Subscription;
  private _reportDateService: ReportDateService;

  public get reportDateService(): ReportDateService {
    if (!this._reportDateService) {
      this._reportDateService = ReportDateService.shared(this._studioConfigService);
    }
    return this._reportDateService;
  }

  departmentData = this._fieldsService.studentDepartmentData();
  instructorData = this._fieldsService.instructorData();
  executiveData = this._fieldsService.instructorsExecutive();
  juniorExecutiveData = this._fieldsService.instructorsJuniorExecutive();
  standingTypeData = this._fieldsService.standingTypeData();
  WeeksForYearData = this._fieldsService.WeeksForYearData();
  LastFourYearsData = this._fieldsService.LastFourYearsData();

  // Other component refs.
  EventLessonEntityComponent = EventLessonEntityComponent
  EventServicesEntityComponent = EventServicesEntityComponent;
  EventSchedulesEntityComponent = EventSchedulesEntityComponent;
  EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  PaymentsEntityComponent = PaymentsEntityComponent;
  EnrollmentEntityComponent = EnrollmentEntityComponent;
  EnrollmentDropComponent = EnrollmentDropComponent;
  EnrollmentViewLessonComponent = EnrollmentViewLessonComponent;
  SendUpdateAPIComponent = SendUpdateAPIComponent;
  StudentInquiryDetailsComponent = StudentInquiryDetailsComponent;
  MiscServiceDeductionsEntityComponent = MiscServiceDeductionsEntityComponent;
  SignatureEnrollmentComponent = SignatureEnrollmentComponent;

  @ViewChild('f') form: NgForm;
  @ViewChild('displayTable') displayTable;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns: string[] = [
    'example',
  ];

  dataSource: MatTableDataSource<unknown>;
  ShowProgressBar: boolean = true;
  autoCompleteOptions: any;
  queryParams: { parameter: string, value: string }[] = [];
  routeParams: any;
  sortParams: any;
  paginationTotalPages: number = 0;
  paginationIndex: number = 0;
  pageSize: number = 0;
  pageEvent: PageEvent;

  autoCompleteCategoryOptions: any = [];
  autoCompleteEnrollmentOptions: any = [];
  autoCompleteStudentAccountOptions: any = [];
  autocompleteInstructorOptions: any = [];
  autocompleteCustomerNameOptions: any = [];
  autoCompleteFirstNameOptions: any = [];
  autoCompleteLastNameOptions: any = [];
  autoCompleteFirstLastNameOptions: any = [];
  autoCompletePaymentIDOptions: any = [];

  isLoading: boolean = false;

  override onSubmit(form: NgForm): void {
    // fix for form submitting on (blur) and (input)
    if (this.ShowProgressBar) { return; }

    // if (this.isLocked) {return}
    // this.isLocked = true;

    LoggerService.log('submitting form values', form.form.value)

    // Convert date value(s) to what Drupal expects. YYYY/MM/DD
    for (const property in form.form.value) {
      if (moment.isMoment(form.form.value[property]) == true) {
        form.form.value[property] = (form.form.value[property]) ? moment(form.form.value[property]).format('YYYY-MM-DD') : '';
      }
    }

    // Build query params.
    this.queryParams = [];
    for (const property in form.form.value) {
      if (form.form.value[property] && form.form.value[property] != "") {
        this.queryParams.push({ parameter: property, value: form.form.value[property] })
      }
    }

    // Build the route params.
    this.routeParams = new Object;
    for (const property in form.form.value) {
      if (form.form.value[property] && form.form.value[property] != "") {
        // let append = { {property}: form.form.value[property] }
        this.routeParams = {
          ...this.routeParams,
          [property]: form.form.value[property]
        }
      }
    }

    // Update the query parameters, so the link can be copied.
    // this.updateRouterParams(form.form.value);
    this.updateRouterParams(this.routeParams);
  }

  getData(params: { parameter: string; value: string; }[]) {
  }

  /**
   * Sets the query parameters in the URL.
   *
   * @param queryParams
   */
  private isUpdatingParams = false;
  // Holds the most recent params requested while a navigation is in flight, so a
  // rapid second call (e.g. sort right after a page change) is replayed instead of
  // silently dropped. `undefined` = nothing pending; a value (incl. {} for "clear")
  // = replay it when the current navigation settles.
  private pendingRouteParams: any = undefined;

  updateRouterParams(routeParams?: any) {

    if (this.isUpdatingParams) {
      // Don't discard. Remember the latest request and replay it when the
      // in-flight navigation finishes (see the finally() handlers below).
      this.pendingRouteParams = routeParams ?? {};
      return;
    }

    this.isUpdatingParams = true;

    const onComplete = () => {
      this.isUpdatingParams = false;
      // Replay the latest queued request, if any.
      if (this.pendingRouteParams !== undefined) {
        const next = this.pendingRouteParams;
        this.pendingRouteParams = undefined;
        this.updateRouterParams(next);
      }
    };

    if (routeParams && Object.keys(routeParams).length > 0) {
      if (!routeParams.hasOwnProperty('page')) {
        LoggerService.log('Adding default page parameter');
        routeParams = {
          ...routeParams,
          page: '0',
        };
      }

      this._router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: routeParams,
        queryParamsHandling: 'merge'
      }).finally(onComplete);

      // Convert route params to queryParams
      this.queryParams = Object.entries(routeParams)
        .filter(([key]) => key !== 'timestamp')
        .map(([parameter, value]) => ({ parameter, value: value as string }));
    } else {
      LoggerService.log('Clearing all query params');
      this._router.navigate([], {
        relativeTo: this._activatedRoute,
        queryParams: {},
        queryParamsHandling: ''  // This will clear all existing query params
      }).finally(onComplete);

      this.queryParams = [];
      this.routeParams = {}; // Clear routeParams when clearing all params
    }

  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    if (!this._reportDateService) {
      this._reportDateService = ReportDateService.shared(this._studioConfigService);
    }

    // Check for query params.
    this.subscription = this._activatedRoute.queryParams
      .subscribe((routeParams: Params) => {
        // The base class never applies route params to the table: a4aa5f3c9c
        // (Jan 2023) meant to skip only the student-dashboard tables, but its
        // `name == 'A' || 'B' || 'C'` check was always true (and constructor
        // names are minified in production anyway). Tables that filter from the
        // URL call updateRouterParams() in their own ngOnInit; applying it here
        // would rewrite the host page's URL from tables embedded in dialogs.
        // Load the data.
        this.getData(this.queryParams)
      });
  }

  updatePaginationConfig(dataRows) {
    // Update pageSize
    if (dataRows == undefined) {
      this.pageSize = 0;
    } else {
      this.pageSize = dataRows.length
    }

    if (dataRows && this?.paginator) {
      this.paginator.length = dataRows?.length ?? '';
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = this.paginationIndex;
    }
  }

  /**
   * Handle sort parameters here. Rely on API to sort.
   *
   * @param sort
   */
  sortData(sort: Sort) {
    this.sortParams =
    {
      // toUppercase() is needed here.
      stype: sort.direction.toUpperCase(),
      sort: sort.active
    }

    // Don't forget the existing parameters.
    // LoggerService.log('this.sortParams')
    // LoggerService.log(this.sortParams)
    // if (this.sortParams) {
    //   this.routeParams = {
    //     ...this.routeParams,
    //     ...
    //   }
    // }

    this.updateRouterParams(this.sortParams)
  }

  /**
   * Handle sort parameters here for Drupal Views.
   *
   * @param sort
   */
  sortDataView(sort: Sort) {
    if (sort.direction == '' || sort.active == '') {
      this.sortParams = {};
      delete this.routeParams.sort_order;
      delete this.routeParams.sort_by;
    } else {
      this.sortParams =
      {
        // toUppercase() is needed here.
        sort_order: sort.direction.toUpperCase(),
        sort_by: sort.active
      }
    }

    // Don't forget the existing parameters.
    if (this.routeParams) {
      this.routeParams = {
        ...this.routeParams,
        ...this.sortParams
      }
    } else {
      this.routeParams = {
        ...this.sortParams
      }
    }

    this.updateRouterParams(this.routeParams)
  }

  onPageSizeOptions() {
    return [25];
  }

  /**
   * Handle pagination.
   *
   * @param event
   */
  pageChanged(event: PageEvent) {
    LoggerService.log('pageChanged called...');

    let paginationParams = {
      page: event.pageIndex.toString(),
      timestamp: new Date().getTime().toString()
    };

    this.updateRouterParams({ ...this.routeParams, ...paginationParams });
  }

  /**
   * Handle when a user wants to print the page. Shortcut for CTRL + P.
   */
  onPrint() {
    window.print();
  }

  /**
   * Handle onDownloadCSV click.
   */
  onDownloadCSV() {
    this.downloadFile(this.data['#events']);
  }

  /**
   * Download a CSV using a Drupal View export.
   */
  downloadCSVDrupalViews(route: string, filename: string, params: any) {
    this.isLoading = true; // Start loading
    LoggerService.log('param', params);

    // Process the params for start and end dates.
    const processedParams = this.processParams(params);
    // Append _format=csv to the route correctly
    const csvRoute = route.includes('?') ? `${route}&_format=csv` : `${route}?_format=csv`;

    this._drupalRESTService.downloadFile(csvRoute, params)
      .subscribe((response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response.body);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (filename) {
          downloadLink.setAttribute('download', filename + '.csv');
        }
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isLoading = false;
      }, error => {
        LoggerService.error(error);
        this.isLoading = false;
      });
  }

  /**
   * Quick & dirty way to get CSV's working.
   */
  downloadFile(data: any) {
    const replacer = (key: any, value: any) => value === null ? '' : value; // specify how you want to handle null values here
    const header = Object.keys(data[0]);
    let csv = data.map((row: { [x: string]: any; }) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var blob = new Blob([csvArray], { type: 'text/csv' })
    saveAs(blob, "data.csv");
  }

  /**
   * Reset any parameters and clear form and state data.
   */
  resetForm() {
    // Clear all stored params and state
    this.queryParams = [];
    this.sortParams = undefined;
    this.routeParams = {}; // Clear routeParams to prevent old filters from persisting

    // Reset pagination
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    // Clear the form
    this.form.resetForm();

    // Make a fresh request with no params
    this.getData([]);

    // Update router last
    this.updateRouterParams({});
  }

  /**
   * Nuke the results in a mat data table.
   */
  clearFormTableData() {
    this.dataSource = null;
    this.data = null;
  }

  onAutocomplete(term: string, eckType: string, bundle: string, field: string) {
    return this._utilityService.getAMTAbstractAutocomplete(term, eckType, bundle, field);
  }

  onViewsAutocompleteFiltersCategory($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilters()
      .subscribe(data => {
        this.autoCompleteCategoryOptions = data;
      })
  }

  onViewsAutocompleteEmail($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("inquiry", "page_1", "field_email_value", $event.target.value)
      .subscribe(data => {
        LoggerService.log(data);
        this.autoCompleteOptions = data;
      })
  }

  onViewsAutocompleteFiltersID($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("payment_reports", "page_1", "field_payment_id_value", $event.target.value)
      .subscribe(data => {
        LoggerService.log(data);
        this.autoCompletePaymentIDOptions = data;
      })
  }

  // Handle the autocomplete for package field.
  onViewsAutocompletePackages($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("enrollment", "page_1", "field_package_name_value", $event.target.value)
      .subscribe(data => {
        this.autoCompletePackageOptions = data;
      })
  }

  // Handle the autcomplete for customer name field.
  onViewsAutocompleteCustomerName($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("payment_reports", "page_1", "field_customer_name_value", $event.target.value)
      .subscribe(data => {
        this.autocompleteCustomerNameOptions = data;
      })
  }

  // Handle the autcomplete for student field.
  onFirstNameInput($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("inquiry", "page_1", "field_first_name_value", $event.target.value)
      .subscribe(data => {
        this.autoCompleteFirstNameOptions = data;
      })
  }

  onLastNameInput($event: { target: { value: string; }; }) {
    this._utilityService.getViewsAutocompleteFilter("inquiry", "page_1", "field_last_name_value", $event.target.value)
      .subscribe(data => {
        LoggerService.log(data);
        this.autoCompleteLastNameOptions = data;
      })
  }

  onFirstLastNameInput($event: { target: { value: string; }; }) {
    let term: string = $event.target.value;
    let eckType: string = 'user';
    let bundle: string = '';
    let field: string = 'filterBasedOnNameAndLastName';

    this.onAutocomplete(term, eckType, bundle, field)
      .subscribe(data => {
        this.autoCompleteFirstLastNameOptions = data;
      });
  }

  onEnrollmentAutocomplete($event: { target: { value: string; }; }) {
    this._utilityService.getAutocompleteEnrollment($event)
      .subscribe(data => {
        this.autoCompleteEnrollmentOptions = data;
      });
  }

  // Handle the autocomplete for instructor field.
  onAutocompleteInstructor($event: { target: { value: string; }; }) {
    let term: string = $event.target.value;
    let eckType: string = 'user';
    let bundle: string = 'instructor';
    let field: string = 'filterBasedOnNameAndLastName';

    this.onAutocomplete(term, eckType, bundle, field)
      .subscribe(data => {
        this.autocompleteInstructorOptions = data;
      });
  }


  // Handle the autocomplete for student filter field.
  onAutocompleteStudentAccount($event: { target: { value: string; }; }) {
    let term: string = $event.target.value;
    let eckType: string = "student_accounts"; // student_accounts
    let bundle: string = "student_account"; // student_account
    let field: string = "title";

    this.onAutocomplete(term, eckType, bundle, field)
      .subscribe(data => {
        this.autoCompleteStudentAccountOptions = data;
      })
  }

  openEnrollmentComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    this._dialogService.openDialog(component, "enrollmentFormWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // this.refreshCalendar();
      this.getData(this.queryParams);
    });
  }

  openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    // Enrollment form needs the wider dialog to match the "Add Enrollment" button on the Enrollment List.
    const dialogConfig = component === EnrollmentEntityComponent ? "enrollmentFormWithData" : "defaultWithData";
    this._dialogService.openDialog(component, dialogConfig, {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // this.refreshCalendar();
      this.getData(this.queryParams);
    });
  }

  openEntityComponentPayment(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    LoggerService.log('openEntityComponentPayment called...')
    this._dialogService.openDialog(component, "paymentFormWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // this.refreshCalendar();
      this.getData(this.queryParams);
    });
  }

  openEntityComponentXL(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    this._dialogService.openDialog(component, "defaultXL", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      // this.refreshCalendar();
      this.getData(this.queryParams);
    });
  }

  /**
   * Utility to open dialogs with a default configuration.
   *
   * @param formName
   * @param dialogConfig
   */
  openDialog(component: ComponentType<unknown>, dialogConfig = 'defaultWithData', data?) {
    let dialogRef = this._dialogService.openDialog(component, dialogConfig ?? "defaultWithData", {
      data,
    }).afterClosed().subscribe(data => {
      // this.refreshCalendar();
    });
  }

  /**
   * Handle common parameters for Drupal Views.
   *
   * @param params
   * @returns
   */
  processParams = (params: any): HttpParameter[] => {
    if (!params) {
      return [];
    }

    const start_date = params['start_date'] ? moment(params['start_date']).format('YYYY-MM-DD') : '';
    const end_date = params['end_date'] ? moment(params['end_date']).format('YYYY-MM-DD') : '';

    // contextual_range_filter's date_range plugin interprets a one-sided
    // value like "2025-01-10--" as ">=start" (open-ended to infinity) and
    // "--2025-01-10" as "<=end". Users picking a single date via the
    // date-range picker expect a same-day filter, not "everything from X
    // onward". Normalize: if only one side is set, apply it to both.
    let from = start_date;
    let to = end_date;
    if (from && !to) {
      to = from;
    } else if (to && !from) {
      from = to;
    } else if (!from && !to) {
      // No date filter: omit the param so the view falls back to "all".
      return [];
    }

    return [{ parameter: 'field_payment_date', value: `${from}--${to}` }];
  };

  setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');

    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }

    // Convert params to router params format and update URL
    const routerParams = params.reduce((acc, param) => ({
      ...acc,
      [param.parameter]: param.value
    }), {});

    if (routerParams) {
      // Check if the current route parameters are the same as the new ones
      const currentParams = this._activatedRoute.snapshot.queryParams;
      const isSameParams = Object.keys(routerParams).every(key => currentParams[key] === routerParams[key]);

      if (isSameParams) {
        LoggerService.log('Route parameters unchanged, skipping navigation');
        return;
      }
      this.updateRouterParams(routerParams);
    }
  }


  // override handleError(error: any) {
  //   LoggerService.log("handleError called...");
  //   LoggerService.log(error);
  //   this.ShowProgressBar = false;

  //   this.errorMessage = "There was an error.";
  // }

  getPaymentIcon(paymentType: string): string {
    switch (paymentType) {
      case 'visa':
        return 'fab fa-cc-visa';
      case 'mastercard':
        return 'fab fa-cc-mastercard';
      case 'amex':
        return 'fab fa-cc-amex';
      case 'discover':
        return 'fab fa-cc-discover';
      default:
        return '';
    }
  }

}
